<template>
  <div class="summary-row-container">
    <div class="summary-row-cell left">
      <slot name="description" />
    </div>
    <div class="summary-row-cell right">
      <slot name="value" />
    </div>
  </div>
</template>
<style lang="scss" scoped>
/* stylelint-disable selector-class-pattern */
.summary-row-container {
  display: flex;
  justify-content: space-between;
  font-family: var(--editor-default-font-family);
  gap: var(--spacing-50);
  min-width: 0;

  .summary-row-cell {
    min-width: 20%;
    overflow-wrap: break-word;

    &.left {
      flex: 1 1 0;
    }

    &.right {
      display: flex;
      justify-content: flex-end;
    }
  }
}
</style>
